import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { ThunkDispatchType } from 'app/redux/types';

import { PickPresetAmount, pickPresetAmount } from '../../../../actions/stakeTypes';
import TextWithAmountBar from '../../../TextWithAmountBar';

import dictionary from './PladgeStake.dictionary.json';

// ---

type PledgeStakeMaxWinningProps = {
  value: number;
  betId: number;
  hasError?: boolean;
};

const PledgeStakeMaxWinning: FC<PledgeStakeMaxWinningProps> = ({
  betId,
  value,
  hasError,
}) => {
  const dispatch: ThunkDispatchType<PickPresetAmount> = useDispatch();

  const pickPresentAmountHandler = useCallback(() => {
    dispatch(pickPresetAmount(value, betId));
  }, [value, betId]);

  return (
    <TextWithAmountBar value={value}
                       hasError={hasError}
                       data-test="entry-pledgeStakeMaxWinning"
                       label={dictionary.maxWinningLabel}
                       onClick={pickPresentAmountHandler} />
  );
};

export default PledgeStakeMaxWinning;
